// Canonical indicator-band blocks for curated templates — now SAFE TSL (declarative AST), not JS bodies.
// Parsed from canonical TSL text at load; executed by the controlled interpreter. Parity with the prior JS
// bodies is pinned bit-for-bit by scripts/test-tsl-template-parity.mjs (Donchian + BB-middle exact; BB
// stdev bands within ~1e-14 FP). Templates reference these as `data.tslAst` (no executable source).

import { parseBlock } from '../engine/tslBlock/blockText';
import type { TslBlock } from '../engine/tslBlock/ast';

const tsl = (text: string): TslBlock => { const r = parseBlock(text); if (!r.ok) throw new Error(`canonical band TSL parse error: ${JSON.stringify(r.errors)}`); return r.block; };

// Bollinger: middle = SMA(close, period); upper/lower = middle ± stdDev·STDEV(close, period). Population
// stdev (matches engine indicators.ts + TradingView). `basis='sma'` is the only basis the templates use.
export const CANONICAL_BB_MIDDLE_TSL = tsl(`indicator {
  param period: int 2..400 = 20
  param stdDev: float 0.1..5 = 2
  value: sma(close, period)
}`);
export const CANONICAL_BB_LOWER_TSL = tsl(`indicator {
  param period: int 2..400 = 20
  param stdDev: float 0.1..5 = 2
  value: (sma(close, period) - (stdDev * stdev(close, period)))
}`);
export const CANONICAL_BB_UPPER_TSL = tsl(`indicator {
  param period: int 2..400 = 20
  param stdDev: float 0.1..5 = 2
  value: (sma(close, period) + (stdDev * stdev(close, period)))
}`);

// Donchian: highest-high / lowest-low of the PRIOR `period` bars (EXCLUDES current). prev(highest(...),1)
// is exactly "highest of the period bars ending one bar back" — bit-identical to the old exclusive loop.
export const CANONICAL_DONCHIAN_UPPER_TSL = tsl(`indicator {
  param period: int 2..400 = 20
  value: prev(highest(high, period), 1)
}`);
export const CANONICAL_DONCHIAN_LOWER_TSL = tsl(`indicator {
  param period: int 2..400 = 20
  value: prev(lowest(low, period), 1)
}`);
